import type { IEntity } from '@/Module/Core/Model/DataModel';

export const ALL_ID: IEntity['id'] = 0;
